var gql = require("@apollo/client").gql;

const PROVIDERS_WITH_TARIFFS_QUERY_FOR_SEO = gql`
    query PROVIDERS_WITH_TARIFFS_QUERY_FOR_SEO(
        $tariffFilter: String
        $providerLimit: Int
        $providerOffset: Int
        $tariffsPerProvider: Int
        $providerJoin: Boolean
        $vipProvider: Boolean
        $firstExclusive: Boolean
        $fillFieldInfo: Boolean
    ) {
        providersWithTariffs(
            tariffFilter: $tariffFilter
            providerLimit: $providerLimit
            providerOffset: $providerOffset
            tariffsPerProvider: $tariffsPerProvider
            providerJoin: $providerJoin
            vipProvider: $vipProvider
            firstExclusive: $firstExclusive
            fillFieldInfo: $fillFieldInfo
        ) {
            pagination {
                items_total
            }
            providersName
            data {
                id
                name
                internet {
                    speed_in
                }
            }
        }
    }
`;

export default PROVIDERS_WITH_TARIFFS_QUERY_FOR_SEO;
